import { api } from './client';

export interface FxRate {
  from: string;
  to: string;
  rate: number;
  date: string;
}

export const fxApi = {
  /** Value of 1 unit of `from` expressed in `to`. */
  rate: (from: string, to: string) =>
    api.get<FxRate>('/fx/rate', { params: { from, to } }).then(r => r.data),
};
